import React, { useEffect, useMemo, useState } from "react";
import DefaultModal from "../../DefaultModal";
import { useTranslation } from "react-i18next";
import "./details-payout.scss";
import { API_USER } from "../../../../api/user";
import { ENUM_PAYOUT_TYPE } from "../../../../store/enums";
import { ENUM_DEPOSIT_STATUS } from "../../../../utils/utils";
import useDecimalValue from "../../../../hooks/useDecimalValue";

export default function DetailsPayouts({ isOpen, closeModal, invoiceId }) {
  const { t } = useTranslation();
  const { getDecimalValue } = useDecimalValue();

  const [details, setDetails] = useState({});
  const [statuses, setStatuses] = useState([]);

  useEffect(() => {
    setDetails({});
    if (!invoiceId) return;

    API_USER.balance
      .userPayoutInfo({ invoiceId })
      .then((e) => {
        const data = e.data.data;
        setDetails(data.invoice);
        setStatuses(data.statusList);
      })
      .catch(console.log);
  }, [invoiceId]);

  const detailsFields = useMemo(() => {
    const fields = [
      {
        fields: [
          { title: "Withdrawal amount", value: details.invoiceAmount, isCurrency: true },
          { title: "Commission", value: details.commission, isCurrency: true },
          { title: "Amount to be received", value: details.payoutAmount, isCurrency: true },
          { title: "Status", value: t(ENUM_DEPOSIT_STATUS[statuses[details.status]]) }
        ],
        currency: details.currency
      }
    ];

    const phoneFields = {
      fields: [
        { title: "Phone number", value: details.phoneNumber },
        { title: "Bank name", value: t(details.bank) }
      ]
    };

    const cardFields = {
      fields: [{ title: "Card number", value: details.cardNumber }]
    };

    const accFields = {
      fields: [
        { title: "Card number", value: t(details.bank) },
        { title: "Account number", value: details.accNumber }
      ]
    };
    const cryptoFields = {
      fields: [{ title: "Crypto wallet", value: details.address }]
    };

    let dopFields = { fields: [] };
    if (details.payoutType == ENUM_PAYOUT_TYPE.card) dopFields = cardFields;
    if (details.payoutType == ENUM_PAYOUT_TYPE.phone) dopFields = phoneFields;
    if (details.payoutType == ENUM_PAYOUT_TYPE.acc) dopFields = accFields;
    if (details.payoutType == ENUM_PAYOUT_TYPE.crypto) dopFields = cryptoFields;

    if (details.recipient) {
      dopFields.fields.unshift({ title: "Recipient", value: details.recipient });
    }

    fields.unshift(dopFields);

    return fields;
  }, [details]);

  return (
    <DefaultModal
      miniModal
      isOpen={isOpen}
      closeModal={closeModal}
      classModal="my-details-payouts-modal">
      <h3>
        {t("Payment Request")} # {invoiceId}
      </h3>

      <div className="my-details-payouts__content">
        <div className="my-details-payouts__content__card">
          {detailsFields.map((detail, indx) => (
            <div key={"detail_" + indx} className="details-card__block">
              <h4>{t(detail.title)}</h4>
              <div className="details-card__block__content">
                {detail.fields.map((field, indx2) => (
                  <div className="details-card__block__content__row" key={"field_" + indx2}>
                    <span className="label"> {t(field.title)} </span>
                    <span className="value">
                      {field.isCurrency
                        ? getDecimalValue(field.value, detail.currency)
                        : field.value}{" "}
                      {field.isCurrency && <span className="currency">{detail.currency}</span>}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </DefaultModal>
  );
}
